module.exports = __webpack_public_path__ + "static/media/congratz.e59e9cf7.png";